import { gql } from '@apollo/client';

export const GET_TOP_TRACTION_TYPES = gql`
  query GetTopTractionTypes($filters: DistributionGraphsInput) {
    getTopTractionTypes(input: $filters) {
      amountOfListings
      label
    }
  }
`;
